module.exports = __webpack_public_path__ + "static/media/21ECLAC5.195ac818.jpg";